"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens");

var sizes = function sizes(theme) {
  return {
    sm: {
      borderRadius: _tokens.borderRadius.pill,
      label: theme.typography.label03.desktop,
      padding: _elements.boxPadding.square.xxs,
      icon: {
        width: _tokens.spacing.horizontal.xxs,
        height: _tokens.spacing.vertical.xxs,
        margin: _tokens.spacing.horizontal.xxxxs
      }
    }
  };
};

var _default = sizes;
exports.default = _default;